import React, { useEffect, useState, useRef } from 'react';
import { Box, Grid, Typography, useMediaQuery, IconButton } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UploadReels from '../components/Reels/UploadReels'
import VideoEditorEmbed from '../components/VideoEditorEmbed';
import { generateSearchVideo, getModelName, generateVideoId, videoReelsEditJson, saveReelsVideo } from "../services/apiService";
import { showToast } from '../components/Toast/CommonToast';
import ReelsVideoPlayer from '../components/Reels/ReelsVideoPlayer';
import LoaderWithBackdrop from '../components/Loader/loader';
import ProgressReelsButton from '../components/Reels/ProgressReelsButton';
import { useReelsWebSocket } from '../context/ReelWebSocketProvider';


function Reels() {
    const headerRef = useRef<HTMLDivElement>(null);
    const [headerHeight, setHeaderHeight] = useState(0);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [quotes, setQuotes] = useState<string>('');
    const [duration, setDuration] = useState<string>('6');
    const [allSearchImages, setAllSearchImages] = useState<any[]>([]);
    const [eventIdRes, setEventIdRes] = useState<string>('');
    const [selectedImageId, setSelectedImageId] = useState<any | null>(null);
    const [image, setImage] = useState<string | null>(null);
    const [searchVideoId, setSearchVideoId] = useState<any[]>([])
    const [sharePopup, setSharePopup] = useState<boolean>(false);
    const [scheduledData, setScheduledData] = useState<any>(null);
    const userId = localStorage.getItem("userId") || "";
    const [showEditor, setShowEditor] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [renderVideoDetails, setRenderVideoDetails] = useState<any[]>([]);
    const [selectedVideoIndex, setSelectedVideoIndex] = React.useState<number>(0);
    const [updatedOverlays, setUpdatedOverlays] = useState<any[]>([]);
    const [updatedDuration, setUpdatedDuration] = useState<any | undefined>(undefined);
    const { reconnectWebSocket, saveResponseData } = useReelsWebSocket();
    const [percentages, setPercentages] = useState<any>({});
    const [publishedData, setPublishedData] = React.useState<any>(null);

  useEffect(() => {
    console.log("responseData", saveResponseData)
    if (saveResponseData) {
        setPercentages({
            status: saveResponseData.status,
            percent: saveResponseData.percent,
            errors: saveResponseData.errors,
            videoId: saveResponseData.videoId
        });
    }
}, [saveResponseData]);
useEffect(()=>{
    if(percentages.status === 'done'){
        showToast("Save Video Successfully", 'success');
    }
},[percentages])
    const eventId = Array.isArray(eventIdRes) ? eventIdRes.find((item: any) => item.eventName === "Reels")?._id : '68590b5ec4e2a96de6be37dc';




   const handleSaveVideo = React.useCallback(async () => {
    setIsLoading(true);
    if (renderVideoDetails.length === 0) {
        showToast("No video details available to save.", 'error');
        return;
    }
    reconnectWebSocket();
    const videoId = allSearchImages[selectedVideoIndex]?._id;
    try {
        const paylaod = {
            videoId: videoId,
            eventId: eventId,
            userId: userId,
            json: {
                overlays: [...updatedOverlays],
                durationInFrames: updatedDuration?.durationInFrames,
                fps: updatedDuration?.fps,
                height: updatedDuration?.height,
                width: updatedDuration?.width,
                src: updatedDuration?.src
            },
        }
        const saveReelsVideoId = await saveReelsVideo(paylaod);
        setIsLoading(false);
        console.log("Save Reels Video Response:", saveReelsVideoId);
    } catch (error: any) {
        setIsLoading(false);
        console.error("Error saving video:", error);
        showToast(error?.message, 'error');
    }
}, [
    renderVideoDetails,
    reconnectWebSocket,
    allSearchImages,
    selectedVideoIndex,
    userId,
    updatedOverlays,
    updatedDuration,
    eventId
]);
        useEffect(()=>{
       if(updatedOverlays.length > 0){
         handleSaveVideo()
       }
    },[updatedOverlays])



    useEffect(() => {
        fetchModelName();
    }, [])


    // Modelname geti
    const fetchModelName = async () => {
        try {
            const response = await getModelName("video");
            console.log("Model Name Response:", response);
            if (response.status === "success") {
                setEventIdRes(response.data);
            }
        } catch (error) {
            console.error("Error fetching model name", error);
        }
    }

    //  allSearch Images
    const handleallfetchimages = React.useCallback(async (eventIdToUse: string) => {
        try {
            const payLoadSearch = {
                eventId: eventIdToUse,
                userId: userId
            }
            const response = await generateSearchVideo(payLoadSearch);
            if (response.status === "success") {
                // Duplicate the response data 4 times
                // const duplicated = Array(4).fill(response.data).flat();
                setAllSearchImages(response?.data);
                setSelectedVideoIndex(0); // Reset to first video
                setScheduledData(response?.scheduledYouTubeUpdates);
            }
        } catch (error) {
            console.error("Error fetching video:", error);
        }
    }, [userId]);

     useEffect(() => {
        handleallfetchimages(eventId)
    }, [eventId, handleallfetchimages, showEditor]);

    // Select first item by default when allSearchImages changes
    useEffect(() => {
        if (allSearchImages.length > 0 && !selectedImageId) {
            setSelectedImageId(allSearchImages[0]._id);
        }
    }, [allSearchImages, selectedImageId]);


    const handleSearchVideoId = async (id: any) => {
        try {
            const response = await generateVideoId(id);
            if (response.status === "success") {
                setSearchVideoId(response?.data);
                // Find index of the item with matching _id
                const idx = allSearchImages.findIndex((item: any) => item._id === response?.data?._id);
                if (idx !== -1) {
                    setSelectedVideoIndex(idx);
                }
            } else {
                showToast(response?.message, 'error');
            }
        } catch (error:any) {
            console.error("Error fetching video by ID:", error);
            showToast(error?.message, 'error');
        }
    }
    useEffect(() => {
        if (
            Array.isArray(allSearchImages) &&
            allSearchImages.length > 0 &&
            typeof selectedVideoIndex === "number"
        ) {
            const published = allSearchImages[selectedVideoIndex]?.published;
            let youtubeDataArr: any[] = [];
            if (
                published &&
                typeof published === "object" &&
                Array.isArray(published.youtube) &&
                published.youtube.length > 0
            ) {
                youtubeDataArr = published.youtube;
            }
            setPublishedData(youtubeDataArr);
        } else {
            setPublishedData([]);
        }
    }, [allSearchImages, selectedVideoIndex]);
    //  renderJSon
   const handleFetchJson = React.useCallback(async (id: any) => {
    try {
        const response = await videoReelsEditJson(id);
        if (response.status === "success") {
            setRenderVideoDetails(response?.data);
              const idx = allSearchImages.findIndex((item: any) => item._id === id);
            if (idx !== -1) {
                setSelectedVideoIndex(idx);
            }
            
        } else {
            showToast(response?.message, 'error');
        }
    } catch (error) {
        console.error("Error fetching JSON:", error);
    }
}, [setRenderVideoDetails]);

    React.useEffect(() => {
    if (Array.isArray(allSearchImages) && allSearchImages.length > 0) {
        const latestId = allSearchImages[0]?._id;
        setSelectedImageId?.(latestId);
        handleFetchJson?.(latestId);
    }
}, [allSearchImages, handleFetchJson]);

 const selectedId = allSearchImages[selectedVideoIndex]?._id;

    // Measure header height on mount and resize
    useEffect(() => {
        function updateHeaderHeight() {
            if (headerRef.current) {
                setHeaderHeight(headerRef.current.offsetHeight);
            }
        }
        updateHeaderHeight();
        window.addEventListener('resize', updateHeaderHeight);
        return () => window.removeEventListener('resize', updateHeaderHeight);
    }, []);

    return (
        <Box className="flex-scroll-area">
            {isLoading && <LoaderWithBackdrop open={isLoading} />}
            <Box ref={headerRef} sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mt: 2,
                mb: 1,
                // position: 'sticky',
                top: 0,
                zIndex: 100,
                // background: '#fff',
                // Add a subtle shadow for separation
                boxShadow: '0 2px 8px -4px rgba(0,0,0,0.08)'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {showEditor && (
                    <IconButton onClick={() => setShowEditor(false)} sx={{ mr: 1 }}>
                        <ArrowBackIcon />
                    </IconButton>
                )}
                <Typography variant="h1" className='productHeading'>
                    Reels
                </Typography>
                </Box>
               {showEditor &&
                percentages.status === "in-progress" &&
                selectedId === percentages.videoId ? (
                    <ProgressReelsButton
                    percentage={percentages?.percent * 100}
                    status={percentages.status}
                    />
                ) : null}
            </Box>
            {showEditor ? (
                <VideoEditorEmbed
                    projectId={selectedImageId || 'test'}
                    overlayData={renderVideoDetails[0]?.renderJson}
                    editor={true}
                    setUpdatedOverlays={setUpdatedOverlays}
                    setUpdatedDuration={setUpdatedDuration}
                />
            ) : (
                <Grid container spacing={2} direction={isMobile ? 'column' : 'row'} >
                    <Grid item xs={12} md={6} lg={5}>
                        <UploadReels duration={duration} setDuration={setDuration} quotes={quotes} setQuotes={setQuotes}
                            setAllSearchImages={setAllSearchImages}
                            allSearchImages={allSearchImages}
                            selectedImageId={selectedImageId}
                            setSelectedImageId={setSelectedImageId}
                            setImage={setImage}
                            image={image}
                            handleFetchJson={handleFetchJson}
                            eventIdRes={eventIdRes}
                            setIsLoading={setIsLoading}
                            isLoading={isLoading}
                            handleSearchVideoId={handleSearchVideoId}
                            headerHeight={headerHeight}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={7}>
                        <ReelsVideoPlayer
                            overlayData={renderVideoDetails[0]?.renderJson}
                            setSharePopup={setSharePopup}
                            sharePopup={sharePopup}
                            searchVideoId={searchVideoId}
                            allSearchImages={allSearchImages}
                            scheduledData={scheduledData}
                            onOpenEditor={() => setShowEditor(true)}
                            setAllSearchImages={setAllSearchImages}
                            handleFetchJson={handleFetchJson}
                            setRenderVideoDetails={setRenderVideoDetails}
                            setSelectedVideoIndex={setSelectedVideoIndex}
                            selectedVideoIndex={selectedVideoIndex}
                            renderVideoDetails={renderVideoDetails}
                            setPublishedData={setPublishedData}
                            publishedData={publishedData}
                        />
                    </Grid>
                </Grid>
            )}
        </Box>
    )
}

export default Reels